"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("path");
const fs_1 = require("fs");
const glob = require("glob");
class FileUtils {
    static getReadStream(filePath) {
        return fs_1.createReadStream(filePath);
    }
    static getWriteStream(filePath) {
        return fs_1.createWriteStream(filePath);
    }
    static getFilePathsFromGlob(pattern, runParams) {
        return new Promise((resolve, reject) => {
            glob(pattern, { ignore: runParams.ignorePatterns }, (err, files) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(files);
                }
            });
        });
    }
    static getOutputFilePath(filePath, runParams, globBase) {
        const { outputDir } = runParams;
        return outputDir ? path_1.join(outputDir, filePath.slice(globBase.length)) : filePath;
    }
    static ensureOutputDir(outputDir) {
        try {
            fs_1.accessSync(outputDir, fs_1.constants.F_OK);
        }
        catch (err) {
            fs_1.mkdirSync(outputDir);
        }
    }
}
exports.default = FileUtils;
